import infoPopup from "./infoPopup";
import styles from './searchInfoPopup.scss';
import ReactHtmlParser from 'react-html-parser';
import FocusTrap from "focus-trap-react";
import { getLocalizedStrings } from "../dashboardLocalizedStrings";
import InfoPopup from '../Common/infoPopup';
export default class SearchInfoPopup extends React.Component {
    constructor(props) {
        super(props);
        
        this.setWrapperRef = this.setWrapperRef.bind(this);
        this.handleClickOutside = this.handleClickOutside.bind(this);
        this.strings = getLocalizedStrings('ratePlanPopUp');
        this.billStrings = getLocalizedStrings('yourBill');
        this.closeIcon = drupalSettings.path.baseUrl + 'themes/custom/sce_responsive/images/Icon_Close.svg';
        this.infoImg = drupalSettings.path.baseUrl + 'themes/custom/sce_responsive/images/dss_search_popup.png';
        
    }

    componentDidMount() {
        //this.fetchRatePlan();
        document.addEventListener('click', this.handleClickOutside);
    }

    componentWillUnmount() {
        document.removeEventListener('click', this.handleClickOutside);
    }

    componentDidUpdate() {
        document.addEventListener('click', this.handleClickOutside);
    }

    setWrapperRef(node) {
        this.wrapperRef = node;
    }

    handleClickOutside(event) {
        (this.wrapperRef && !this.wrapperRef.contains(event.target)) && this.props.handleSearchInfo();
    }
    dssSearchRgx = (imgRgx, contentRgx) => {
        if (!_.isEmpty(this.props.content)) {
            let searchPopUpImg = this.props.content.dss_search_popup.body.match(imgRgx);
            let searchPopUpText = this.props.content.dss_search_popup.body.match(contentRgx);
            let regContent = {
                searchPopUpImage: searchPopUpImg ? ReactHtmlParser(searchPopUpImg) : "",
                searchPopUpContent: searchPopUpText ? ReactHtmlParser(searchPopUpText) : "",
            };
            return regContent;
        }
    }
    getContent() {
        let content = {};
        if (this.props.saAndCaContent) {
            let searchPopUpCASAImgRgx = new RegExp('<span id="search_casaImg">([^]*?)</span>', 'g');
            let searchPopUpTextCASARgx = new RegExp('<div class="search_sacatext">([^]*?)</div>', 'g');
            content = this.dssSearchRgx(searchPopUpCASAImgRgx, searchPopUpTextCASARgx);
        } else if (this.props.caContent) {
            let searchPopUpCAImgRgx = new RegExp('<span id="search_caImg">([^]*?)</span>', 'g');
            let searchPopUpTextCARgx = new RegExp('<div class="search_catext">([^]*?)</div>', 'g');
            content = this.dssSearchRgx(searchPopUpCAImgRgx, searchPopUpTextCARgx);
        } else if (this.props.saContent) {
            let searchPopUpSAImgRgx = new RegExp('<span id="search_saImg">([^]*?)</span>', 'g');
            let searchPopUpTextSARgx = new RegExp('<div class="search_satext">([^]*?)</div>', 'g');
            content = this.dssSearchRgx(searchPopUpSAImgRgx, searchPopUpTextSARgx);
        }
        return content;
    }

    render() {
        let content = this.getContent();
        return (
            <div className={styles.sceSearchInfo}>
                <FocusTrap>
                <div>
                <div className={styles.sceSearchInfoContainer} tabIndex={0}>
                    <div ref={this.setWrapperRef}>
                    <span className={styles.sceSearchInfoCloseHeader}><button className={styles.sceSearchInfoCloseBtn} onClick={()=>this.props.handleSearchInfo()}><img src={this.closeIcon} alt="Close Icon" /></button></span>
                    {/* <div className={styles.sceSearchInfoCloseHeader}><img src={this.closeIcon} tabIndex={0} onClick={()=>this.props.handleSearchInfo()} className={styles.sceSearchInfoCloseBtn} /></div> */}
                    <div className={styles.sceSearchInfoContent}>
                        <div className={styles.sceSearchInfoContentLeft}>
                            {content.searchPopUpContent}
                        </div>
                        <div className={styles.sceInfoImgDiv}>
                            {content.searchPopUpImage}
                        </div>
                    </div></div>
                </div></div></FocusTrap>
            </div>
        );
    }
}
